/**
 * Global AJAX Cart Handler for Product Grid Items
 * Handles dynamically loaded product grids (e.g. recommendations, collections)
 */

(function () {
    'use strict';

    // Initialize a single product form for AJAX cart
    function initProductForm(form) {
        if (!form) return;

        // Check if already initialized
        if (form.dataset.ajaxInitialized === 'true') {
            return;
        }
        form.dataset.ajaxInitialized = 'true';

        const productId = form.dataset.productId;
        console.log('✅ Initializing AJAX cart for product:', productId);

        // Handle form submission via AJAX
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const formData = new FormData(form);

            // Validate variant selection (if needed)
            const variantSelector = form.querySelector('[data-single-option-selector]');
            if (variantSelector && (!variantSelector.value || variantSelector.value === '')) {
                const errorMessage = document.getElementById('variant-error-' + productId);
                if (errorMessage) {
                    errorMessage.style.display = 'block';
                }
                variantSelector.style.borderColor = '#d74132';
                setTimeout(function () {
                    if (errorMessage) errorMessage.style.display = 'none';
                    variantSelector.style.borderColor = '';
                }, 3000);
                return false;
            }

            // Disable button during request
            const submitButton = form.querySelector('button[type="submit"]');
            const originalText = submitButton.textContent;
            submitButton.disabled = true;
            submitButton.textContent = 'Wird hinzugefügt...';

            console.log('➕ Adding product to cart via AJAX...');

            // AJAX Request to add to cart WITH SECTIONS
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: formData.get('id'),
                        quantity: 1
                    }],
                    sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
                    sections_url: window.location.pathname
                })
            })
                .then(response => response.json())
                .then(data => {
                    console.log('✅ Product added successfully!');
                    console.log('📊 Response:', data);

                    // Fire the cascade event to trigger modal cart opening
                    document.body.dispatchEvent(new CustomEvent('cascade:modalcart:afteradditem', {
                        bubbles: true,
                        detail: { response: data }
                    }));

                    // Reset button
                    submitButton.disabled = false;
                    submitButton.textContent = originalText;
                })
                .catch(error => {
                    console.error('❌ Error adding to cart:', error);
                    submitButton.disabled = false;
                    submitButton.textContent = originalText;
                    alert('Fehler beim Hinzufügen zum Warenkorb');
                });

            return false;
        });

        // Event Listener for variant changes
        const variantSelector = form.querySelector('[data-single-option-selector]');
        if (variantSelector && variantSelector.dataset.priceChangeInitialized !== 'true') {
            variantSelector.dataset.priceChangeInitialized = 'true';

            variantSelector.addEventListener('change', function () {
                const selectedOption = this.options[this.selectedIndex];
                const variantPrice = selectedOption.getAttribute('data-price');
                const variantComparePrice = selectedOption.getAttribute('data-compare-price');
                const errorMessage = document.getElementById('variant-error-' + productId);
                const priceElement = document.getElementById('price-' + productId);
                const comparePriceElement = document.getElementById('compare-price-' + productId);

                // Hide error message when variant is selected
                if (this.value && errorMessage) {
                    errorMessage.style.display = 'none';
                    this.style.borderColor = '';
                }

                // Update price
                if (priceElement && variantPrice) {
                    const formattedPrice = (variantPrice / 100).toFixed(2).replace('.', ',');
                    priceElement.textContent = '€' + formattedPrice;
                }

                // Update compare price - only show if variant has compare_at_price
                if (comparePriceElement) {
                    if (variantComparePrice && parseInt(variantComparePrice) > parseInt(variantPrice)) {
                        const formattedComparePrice = (variantComparePrice / 100).toFixed(2).replace('.', ',');
                        comparePriceElement.textContent = '€' + formattedComparePrice;
                        comparePriceElement.style.display = 'inline';
                    } else {
                        comparePriceElement.style.display = 'none';
                    }
                }
            });
        }
    }

    // Initialize all product forms on the page
    function initAllProductForms() {
        const forms = document.querySelectorAll('.add-cart-item-form');
        console.log(`🔍 Found ${forms.length} product forms to initialize`);

        forms.forEach(form => {
            initProductForm(form);
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllProductForms);
    } else {
        initAllProductForms();
    }

    // Watch for dynamically added product grids (Alpine.js x-html, AJAX loaded content)
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) { // Element node
                    // Check if the added node is a form or contains forms
                    if (node.classList && node.classList.contains('add-cart-item-form')) {
                        initProductForm(node);
                    } else if (node.querySelectorAll) {
                        const forms = node.querySelectorAll('.add-cart-item-form');
                        forms.forEach(initProductForm);
                    }
                }
            });
        });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    console.log('🎯 Product Grid AJAX Handler initialized with MutationObserver');
})();
